import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Home from './pages/Home';
import  './App.css';

/*

     ********** JSX **********

     JSX : ES UN LENGUAJE DE SINTAXIS QUE DETERMINA COMO DEBEN DE ESTRUCTURARSE LAS VISTAS DE LOS COMPONENTES

     * SE RECOMIENDA USAR camelCase PARA LAS PROPIEDADES, METODOS, ETC..., AL USAR JSX CON REACT

     * PARA EJECUTAR CODIGO JS DENTRO DE REACT CON JSX SE DEBE DEFINIR DRENTRO DE : { }

     ********** CSS **********

     * PARA DEFINIRLE ESTILOS CSS A UN TAG O COMPONENTE POR MEDIO DE CLASES SE DEBE DEFINIR DE LA SIGUIENTE MANERA : className='' NO!! : class=''

     ********** JS **********

     * PARA DEFINIR FUNCIONES DE JS SE DEBEN DE DEFINIR DENTRO DEL COMPONENTE

     ********** COMPONENTES **********

     * SE RECOMIENDA SEPARAR LOS COMPONENTES DEL RESTO DEL PROYECTO POR MEDIO DE UN ARCHIVO EN ESPECIFICO

     * AL CREAR UN COMPONENTE EL PRIMER PASO ES IMPORTAR REACT A EL COMPONENTE

     * DESPUES ES CREAR, DECLARAR ( DEFINIR ) EL COMPONENTE POR MEDIO DE LA FUNCTION : class

     * DEPUES SI SE DESEA, PERMITIR EXPORTAR EL COMPONENTE PARA HACER USO DE EL EN OTROS COMPONENTES POR MEDIO DE : export default

     * PARA QUE REACT RECONOZCA HA EL COMPONENTE SE TIENE QUE HEREDAR DE UNA SUPER CLASE DE REACT QUE SE LLAMA : extends React.Component

     * DESPUES AL COMPONENTE DEBE DEFINIRSELE UN METODO : render( ){ }

     * render( ){ } : ESTE METODO DEBE RETORNAR POR MDEIO DE UN : return( ), EL RESULTADO DESEADO A MOSTRARSE EN EL COMPONENTE

     * LOS COMPONENTES DE CLASE POR LO GENERAL CONSERVAN UN state

     * LOS ARGUMENTOS Y ENTRADA DE DATOS A LOS COMPONENTES ES POR MEDIO DEL USO DE props

     * props : SON LA ENTRADA DE DATOS PARA LOS COMPONENTES

     -- Los props no se puede modificar, los datos que recibimos se conservan así, y nada los mueve.

     -- Cuando queremos tener datos dentro del componente que se pueden modificar, lo asignamos al estado del componente.

     * CADA COMPONENTE CONSERVA SU PROPIO ESTADO

     * EL constructor DE UN COMPONENTE SIEMPRE RECIVE COMO ARGUMENTO LOS props Y DICHOS props DEBEN DE PASARSE A EL constructor DEL COMPONENTE
     PADRE USANDO EL KEY-WORD : super( )

     * INICIALIZAR EL state DEL COMPONENTE DENTRO DEL constructor SE DEFINE EL METODO :  this.state = { }

      * this.state = { }  : PERMITE DEFINIRLE DATOS, PROPIEDADES A EL COMPONENTE COMO DATOS DE INICIO, DATOS QUE SE PUEDEN ACTUALIZAR AL EJECUTARSE EL COMPONENTE

      * setState : ESTE METODO ES EL UNICO QUE NOS PERMITE ACTUALIZAR UN VALOR, DATO DEL state DEL COMPONENTE

      -- SE PASA COMO ARGUMENTO UN JSON QUE VA A TENER LAS MODIFICACIONES QUE SE LE HARAN A EL state DEL COMPONENTE

     ********** IMAGES **********

     * process.env.PUBLIC_URL : ESTE METODO PERMITE DEFINIR CORRECTAMENTE EL SRC DE UNA IMAGEN EN REACT

     ********** EVENTOS **********

     * PARA HACER UN EVENTO EN UN ELEMENTO SOLO SE TIENE QUE DEFINIR EL SIGUIENTE EVENTO : onClick=''

     -- EL NOMBRE QUE SE LE ASIGNARA A EL EVENTO DEBE DE RESPETAR EL camelCase

     * EXMAPLE : onClick={ ( )=> { console.log( "Hello" ) } }

     * this : SE REFIERE A EL COMPONENTE

     ********** CSS **********

     * PARA DEFINIR ESTILOS CSS A LOS ELEMENTOS EXISTEN DIVERSAS FOMAS DE HACERLO

     -- DIRECTAMENTE : style={{ 'color':'black', 'font-family':'Arial' }}

     -- POR UNA CLASE : className=' '

     -- POR ID : id=''

     ********** MATERIAL UI **********

     * Material UI : ES UNA LIBRERIA MUY POPULAR EN REACT PARA EL DISENO DE EL WEB APP

     * COMMANDO EN LA TERMINAL DE MAC : npm install material-ui

     * WWW : material-ui.com

     * SE PUEDEN USAR : cards SON MUY USADAS EN EL INTERFASE CON REACT

     ********** IMPORT DATA IN THE SAME PROJECT **********

     * import data from '../Folder/File'

     ********** ANIMACIONES **********

     * 

*/


class App extends Component
{
  constructor( props )
  {
    super( props )
  }

  // EXAMPLE JS FUNCTION hello( ){ return "Hello REACT =)" }

  render( )
  {
       return(

                    <MuiThemeProvider>

                    <Home></Home>

                    </MuiThemeProvider>

                  )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js